import { render } from "./TextareaWithIcon.vue?vue&type=template&id=12efc6ed&scoped=true"
import script from "./TextareaWithIcon.vue?vue&type=script&lang=js"
export * from "./TextareaWithIcon.vue?vue&type=script&lang=js"

import "./TextareaWithIcon.vue?vue&type=style&index=0&id=12efc6ed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12efc6ed"]])

export default __exports__